export const ColumnLineChartDataYears = {
  chart: {
    backgroundColor: "#f7f7f7",
    height: "250px"
  },
  plotOptions: {
    line: {
      marker: {
        enable: false
      },
      dataLabels: {
        enabled: true,
        format: "<b>{point.name}</b>: {point.percentage:.1f} %"
      }
    }
  },
  title: {
    text: ""
  },
  xAxis: [
    {
      categories: ["7", "8", "9", "10", "11", "12", "13", "14", "15"],
      crosshair: true,
      labels: {
        format: "{value}",
        style: {
          color: "#666666"
        }
      },
      title: {
        text: "Anni",
        style: {
          color: "#666666"
        }
      }
    }
  ],
  yAxis: [
    {
      // Primary yAxis
      labels: {
        style: {
          color: "#666666"
        }
      },
      title: {
        text: "Valore (€)",
        style: {
          color: "#666666"
        }
      }
    }
  ],
  credits: {
    enabled: false
  },
  // tooltip: {
  //   formatter: function () {
  //     var point = this.points[0].point,
  //       cats = point.series.xAxis.categories;
  //
  //     var catIndex = point.index,
  //       currCat = cats[catIndex],  //..or simply "this.x"
  //       nextCat = cats[catIndex+1] || '';
  //
  //     var s = '<b>' + currCat + ' - ' + nextCat + '</b>';
  //
  //     $.each(this.points, function () {
  //       s += '<br/>' + this.series.name + ': ' +
  //         this.y + 'm';
  //     });
  //
  //     return s;
  //   },
  //   shared: true
  // },
  legend: {
    layout: "horizontal",
    align: "left",
    verticalAlign: "bottom"
  },
  series: [
    {
      name: "Il tuo capitale",
      type: "column",
      color: "#cfd8dc",
      yAxis: 0,
      data: []
      // tooltip: {
      //   valueSuffix: " €"
      // }
    },
    {
      name: "Premio versato",
      type: "spline",
      yAxis: 0,
      color: "#455a64",
      data: [],
      enableMouseTracking: false,
      tooltip: {
        enabled: false
      }
      // tooltip: {
      //   valueSuffix: " €"
      // }
    }
  ]
};
